import { createGlobalStyle } from 'styled-components'

/** Reset.css */
export const resetCss = `
  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed,
  figure, figcaption, footer, header, hgroup,
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }
  article, aside, details, figcaption, figure,
  footer, header, hgroup, menu, nav, section {
    display: block;
  }
  body {
    line-height: 1;
  }
  ol, ul {
    list-style: none;
  }
  blockquote, q {
    quotes: none;
  }
  blockquote:before, blockquote:after,
  q:before, q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
`

type Props = {
  backgroundColor: string
  color: string
}

export const GlobalStyles = createGlobalStyle<Props>`
  ${resetCss}

  :root {
    color-scheme: dark;
  }

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  html,
  body,
  #root {
    width: 100%;
    height: 100%;
    min-height: 100dvh;
    overflow: hidden;
  }

  body {
    padding: 0;
    margin: 0;
    overflow: hidden;
    overscroll-behavior: none;
    background-color: ${props => props.backgroundColor};
    background-image: linear-gradient(180deg, rgba(15, 23, 42, 0.58) 0%, rgba(30, 41, 59, 0.42) 100%);
    font-family: 'Avenir Next', 'Segoe UI Variable Display', 'Segoe UI', sans-serif;
    font-size: 14px;
    line-height: 1.5;
    color: ${props => props.color};
    transition: background-color 240ms ease-out;
  }

  #root {
    position: relative;
    isolation: isolate;
  }

  canvas {
    display: block;
  }

  button,
  input,
  select {
    font: inherit;
    color: inherit;
  }

  button {
    cursor: pointer;
  }

  input {
    font-family: 'IBM Plex Mono', 'Consolas', 'SFMono-Regular', monospace;
    font-size: 14px;
  }

  a {
    color: inherit;
  }

  ::selection {
    background: rgba(148, 163, 184, 0.28);
    color: #f8fafc;
  }
`
